module.exports = __webpack_public_path__ + "img/img_yz_brand@3x.43673aaa.png";